import React from 'react'
import { CustomBrandContainerProps } from './types'
import './index.scss'
import { ImageWrapper } from '@/Components/ImageWrapper/index'
import { SectionWrapper } from '@/Components/SectionWrapper'
import { ImagesCarouselWrapper } from '@/Components/ImagesCarouselWrapper'
import { DescriptionSection } from '@/Components/DescriptionSection'
import { ProductsCarousel } from '@/Components/ProductsCarousel'
import { ProductsShowcase } from '@/Components/ProductsShowcase'

export const CustomBrandContainer: React.FC<CustomBrandContainerProps> = () => {
  const imageUrlBase = 'https://static-file.petz.com.br/platforms/img/product/ecommerce/custom-brand-page'
  const apiBaseUrl = () => {
    // Troca variavel pra stg, solução provisória para testes, depois virá de config
    if (window.location.href.includes('stg-site.labpetz')) {
      return 'https://stg-site.labpetz.com.br'
    }

    return 'https://www.petz.com.br'
  }

  const noCache = '?cache=0.2.5'

  return (
    <div className="custom-brand-container">
      <SectionWrapper>
        <ImageWrapper
          alt="Selections logo"
          desktopProperties={{ height: 'auto', width: 'auto', src: imageUrlBase + '/desktop/selections-logo.jpg' + noCache }}
          mobileProperties={{ height: 'auto', width: 'auto', src: imageUrlBase + '/mobile/selections-logo.jpg' + noCache }}
        />
      </SectionWrapper>

      <SectionWrapper>
        <ImageWrapper
          alt="Alimentação equilibrada"
          desktopProperties={{ height: 432, width: 'auto', src: imageUrlBase + '/desktop/alimentacao-equilibrada.jpg' + noCache }}
          mobileProperties={{ height: 'auto', width: 'auto', src: imageUrlBase + '/mobile/alimentacao-equilibrada.jpg' + noCache }}
        />
      </SectionWrapper>

      <SectionWrapper>
        <ImageWrapper
          alt="Ração seca"
          desktopProperties={{ height: 432, width: 'auto', src: imageUrlBase + '/desktop/racao-seca.jpg' + noCache }}
          mobileProperties={{ height: 'auto', width: 'auto', src: imageUrlBase + '/mobile/racao-seca.jpg' + noCache }}
        />
      </SectionWrapper>

      <SectionWrapper>
        <ImageWrapper
          alt="Para cães"
          desktopProperties={{ height: 364, width: 'auto', src: imageUrlBase + '/desktop/caes.jpg' + noCache, lazy: true }}
          mobileProperties={{ height: 'auto', width: 'auto', src: imageUrlBase + '/mobile/caes.jpg' + noCache, lazy: true }}
        />

        <ProductsCarousel id={'HalfCarouselDogs'} size="half" urls={[`${apiBaseUrl()}/selections-for-pets/f/pet_cachorros?page=1&json=products`]} />
      </SectionWrapper>

      <SectionWrapper>
        <ImageWrapper
          alt="Para gatos"
          desktopProperties={{ height: 364, width: 'auto', src: imageUrlBase + '/desktop/gatos.jpg' + noCache, lazy: true }}
          mobileProperties={{ height: 'auto', width: 'auto', src: imageUrlBase + '/mobile/gatos.jpg' + noCache, lazy: true }}
        />

        <ProductsCarousel id={'HalfCarouselCats'} size="half" urls={[`${apiBaseUrl()}/selections-for-pets/f/pet_gatos?page=1&json=products`]} />
      </SectionWrapper>

      <SectionWrapper>
        <ImageWrapper
          alt="Banner patês"
          desktopProperties={{ height: 432, width: 'auto', src: imageUrlBase + '/desktop/pates.jpg' + noCache, lazy: true }}
          mobileProperties={{ height: 'auto', width: 'auto', src: imageUrlBase + '/mobile/pates.jpg' + noCache, lazy: true }}
        />
      </SectionWrapper>

      <SectionWrapper>
        <ProductsCarousel id={'FirstFullCarousel'} size="full" urls={[`${apiBaseUrl()}/selections-for-pets/f/formato_pate?page=1&json=products`]} />
      </SectionWrapper>

      <SectionWrapper>
        <ImagesCarouselWrapper id="Images carousel" imageAlign="horizontal">
          <ImageWrapper
            alt="Banner sachês"
            desktopProperties={{ height: 364, width: 'auto', src: imageUrlBase + '/desktop/saches.jpg' + noCache, lazy: true }}
            mobileProperties={{ height: 240, width: 240, src: imageUrlBase + '/mobile/saches.jpg' + noCache, lazy: true }}
            href="https://www.petz.com.br/colecao/sache-selections-for-pets"
          />
          <ImageWrapper
            alt="Banner ossos e desidratados"
            desktopProperties={{ height: 364, width: 'auto', src: imageUrlBase + '/desktop/ossos-e-desidratados.jpg' + noCache, lazy: true }}
            mobileProperties={{ height: 240, width: 240, src: imageUrlBase + '/mobile/ossos-e-desidratados.jpg' + noCache, lazy: true }}
            href="https://www.petz.com.br/colecao/selections-for-pets-desidratados"
          />
        </ImagesCarouselWrapper>
      </SectionWrapper>

      <SectionWrapper>
        <ImageWrapper
          alt="Banner petiscos e biscoitos"
          desktopProperties={{ height: 432, width: 'auto', src: imageUrlBase + '/desktop/petiscos-e-biscoitos.jpg' + noCache, lazy: true }}
          mobileProperties={{ height: 'auto', width: 'auto', src: imageUrlBase + '/mobile/petiscos-e-biscoitos.jpg' + noCache, lazy: true }}
        />
      </SectionWrapper>

      <SectionWrapper>
        <ProductsCarousel
          id={'SecondFullCarousel'}
          size="full"
          urls={[
            `${apiBaseUrl()}/cachorro/petiscos-e-ossos/f/marca_selections-for-pets?page=1&json=products`,
            `${apiBaseUrl()}/gato/petiscos/f/marca_selections-for-pets?page=1&json=products`,
          ]}
        />
      </SectionWrapper>

      <SectionWrapper>
        <ImagesCarouselWrapper id="Images carousel" imageAlign="vertical">
          <ImageWrapper
            alt="Banner bifinhos"
            desktopProperties={{ height: 364, width: 'auto', src: imageUrlBase + '/desktop/bifinhos.jpg' + noCache, lazy: true }}
            mobileProperties={{ height: 408, width: 200, src: imageUrlBase + '/mobile/bifinhos.jpg' + noCache, lazy: true }}
            href="https://www.petz.com.br/colecao/bifinhos-selections-for-pets"
          />
          <ImageWrapper
            alt="Banner cuidado oral"
            desktopProperties={{ height: 364, width: 'auto', src: imageUrlBase + '/desktop/cuidado-oral.jpg' + noCache, lazy: true }}
            mobileProperties={{ height: 408, width: 200, src: imageUrlBase + '/mobile/cuidado-oral.jpg' + noCache, lazy: true }}
            href="https://www.petz.com.br/colecao/selections-for-pets-cuidado-oral"
          />
        </ImagesCarouselWrapper>
      </SectionWrapper>

      <SectionWrapper>
        <ProductsShowcase urls={[`${apiBaseUrl()}/selections-for-pets?page=1&np=3&total=58&view=&sort=0&cor=0&pi=&pf=&json=products`]} />
      </SectionWrapper>

      <SectionWrapper>
        <ImageWrapper
          alt="O seu pet também merece comer bem"
          desktopProperties={{ height: 'auto', width: 'auto', src: imageUrlBase + '/desktop/selections-footer.jpg' + noCache, lazy: true }}
        />
      </SectionWrapper>

      <SectionWrapper>
        <DescriptionSection
          title="Selections"
          smallDescription={
            <>
              Os nossos amigos com patinhas merecem o melhor. Por isso, criamos a linha Selections For Pets! Com alimentos premium, ela traz tudo o que os cães e gatos precisam
              para ter saúde e muito sabor.
            </>
          }
          officialStoreImageUrl={imageUrlBase + '/desktop/loja-oficial.webp'}
          description={
            <>
              <p>
                São petiscos, patês e sachês feitos com ingredientes selecionados, que proporcionam uma experiência deliciosa aos&nbsp;
                <a href="https://www.petz.com.br/outros-pets" data-mce-href="https://www.petz.com.br/outros-pets">
                  mascotes
                </a>{' '}
                e praticidade aos tutores. A seguir, conheça em detalhes a Selections For Pets, uma marca exclusiva da Petz!
              </p>
              <h2>Sachês, patês e petiscos para cachorros e gatos</h2>
              <p>
                Uma vida saudável começa com uma alimentação equilibrada. Dessa forma, a linha Selections For Pets traz produtos livres de corantes, aromatizantes e conservantes
                artificiais, enriquecidos com&nbsp;
                <a href="https://www.petz.com.br/cachorro/farmacia/suplementos-e-vitaminas" data-mce-href="https://www.petz.com.br/cachorro/farmacia/suplementos-e-vitaminas">
                  vitaminas
                </a>{' '}
                e minerais.
              </p>
              <p>
                Entre os sucessos da marca, podemos destacar os sachês, patês e <strong>petiscos para cachorros </strong>e gatos. Todos altamente nutritivos, com ótima
                digestibilidade e sabores irresistíveis. Assim, você oferece um cardápio variado para o pet, com nutrientes balanceados, que contribuem para a sua qualidade de
                vida. <strong>&nbsp;</strong>
              </p>
              <h2>Selections For Pets: sabor irresistível e qualidade garantida</h2>
              <p>
                Desenvolvida pela Petz, a Selections For Pets tem tudo o que os&nbsp;
                <a href="https://www.petz.com.br/cachorro" data-mce-href="https://www.petz.com.br/cachorro">
                  cachorros
                </a>{' '}
                e gatos amam: carne fresca, textura palatável e sabor inigualável. Assim agrada aos paladares mais exigentes!
              </p>
              <p>
                Cada opção é elaborada com todo o amor que sabemos que o pet merece, pensando sempre em seu bem-estar e felicidade. Isso porque, além de complementar a dieta, as
                diversas opções de <strong>sachês </strong>e petiscos podem tornar o adestramento mais divertido, servindo de recompensa durante os treinos.
              </p>
              <h2>Cuidados com os petiscos e sachês para gatos e cachorros</h2>
              <p>
                Os petiscos e <strong>sachês para gatos </strong>e cachorros são nutritivos e amados pelos pets. Contudo, é importante oferecê-los com moderação, já que, em
                excesso, eles podem causar obesidade e outros problemas de saúde aos amiguinhos.
              </p>
              <p>
                Além disso, os <strong>petiscos para cães</strong> e gatos devem ter tamanhos e formatos apropriados para a raça, porte e idade do animal. Se tiver dúvidas quanto à
                melhor alternativa, peça orientações ao médico-veterinário. O especialista poderá indicar o produto adequado, assim como as melhores rações para o mascote.
              </p>
              <h2>Procurando sachês e petiscos para cães? Tem na Petz!</h2>
              <p>
                Esperamos que você tenha gostado de conhecer a marca Selections For Pets! Esses e muitos outros petiscos e sachês estão esperando por você no{' '}
                <a href="https://www.petz.com.br/cachorro/petiscos-e-ossos" data-mce-href="https://www.petz.com.br/cachorro/petiscos-e-ossos">
                  Pet Shop
                </a>{' '}
                on-line da Petz, a loja que tudo o que o seu pet precisa!
              </p>
              <p>
                Continue navegando pelo catálogo e confira snacks, sticks, ossos, bifinhos, biscoitos e outros itens que os cães e&nbsp;
                <a href="https://www.petz.com.br/gato" data-mce-href="https://www.petz.com.br/gato">
                  gatos
                </a>{' '}
                adoram. E o melhor, com condições incríveis de pagamento e entrega! Aproveite!
              </p>
            </>
          }
        />
      </SectionWrapper>
    </div>
  )
}
